// src/hooks/usePageTitle.js
import { useEffect } from "react";

// Define o <title> do documento enquanto a página está montada.
export default function usePageTitle(titulo) {
  useEffect(() => {
    document.title = titulo;
  }, [titulo]);
}
